import { useEffect } from "react"

export default function WillowWeb() {

    useEffect(() => {
        document.title = `rw - willow web`;
    }, [])

    return (
        <div id="willow-web">
            <p>
                <a href="https://willow-web.net">willow web</a> is a website to help people organise their thoughts.
                it is a network of rooms, in which users reach towards new ideas, and store notes on old ones.
                only active users can see other's pages, to require a mutual vulnerability.
            </p>
        </div>
    )
}